module.exports = __webpack_public_path__ + "img/features-share.6e6a9d0a.svg";